import type { AccordionTabContext } from "primevue/accordiontab"
export default {
    accordiontab: {
        root: {
            class: "mb-1",
        },
        headerAction: ({ context }: { context: AccordionTabContext }) => ({
            class: [
                // Font
                "leading-none",
                // Alignments
                "flex items-center",
                "relative",
                // Sizing
                "px-2 py-1",
                // Shape
                "rounded-t-md",
                {
                    "rounded-br-md rounded-bl-md": !context.active,
                    "rounded-br-0 rounded-bl-0": context.active,
                },
                // Transition
                "transition duration-200 ease-in-out",
                "transition-shadow duration-200",
                // States
                "hover:bg-surface-100 dark:hover:bg-surface-700/40",
                "hover:text-surface-900",
                "focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 ring-inset dark:focus-visible:ring-primary-300/50",
                // Focus
                // Misc
                "cursor-pointer no-underline select-none  hover:text-hover-link",
                {
                    "text-hover-link": context.active,
                },
            ],
        }),
        headerIcon: {
            class: "inline-block mr-2",
        },
        headerTitle: {
            class: "leading-none",
        },
        content: {
            class: [
                "px-[30px] py-1",
                "rounded-tl-none rounded-tr-none rounded-br-lg rounded-bl-lg",
            ],
        },
        transition: {
            enterFromClass: "max-h-0",
            enterActiveClass:
                "overflow-hidden transition-[max-height] duration-500 ease-[cubic-bezier(0.42,0,0.58,1)]",
            enterToClass: "max-h-[1000px]",
            leaveFromClass: "max-h-[1000px]",
            leaveActiveClass:
                "overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]",
            leaveToClass: "max-h-0",
        },
    },
}
